const recipes = [
  {
    id: 1,
    category: "Breakfast",
    name: "Banana Walnut Pancake with Fruit Medley Recipe",
    price: "39",
    ingredients:
      "1 large mango, 1/4 cup blueberry, 2 tablespoon granulated sugar, 1 1/3 cup low fat milk, 1/2 cup chopped walnuts, 1/4 teaspoon salt, 1 teaspoon virgin olive oil, 1/4 cup strawberry, 1 1/2 cup all purpose flour, 1 teaspoon baking powder, 1 egg, 1/2 cup mashed banana, maple syrup as required",
    imageCover:
      "https://static.toiimg.com/thumb/97911208.cms?imgsize=1506834&width=509&height=340",
    count: 1,
  },
  {
    id: 2,
    category: "Breakfast",
    name: "Strawberry Sandwich",
    price: "29",
    ingredients:
      "1 cup strawberry, 4 bread slices, 1 cup whipped cream, 1 tablespoon honey",
    imageCover:
      "https://static.toiimg.com/thumb/91771773.cms?imgsize=53344&width=509&height=340",
    count: 1,
  },
  {
    id: 3,
    category: "Pasta",
    name: "Pasta Salad",
    price: "22",
    ingredients:
      "200 gm gluten free pasta, 1 cup broccoli, salt as required, 4 leaves lettuce loose-leaf, 4 cup water, 2 small tomato, 1 dash, powdered black pepper, 4 cloves minced garlic, 1 teaspoon mixed herbs",
    imageCover:
      "https://static.toiimg.com/thumb/53150445.cms?imgsize=607362&width=509&height=340",
    count: 1,
  },
  {
    id: 4,
    category: "Pasta",
    name: "Tomato Penne Pasta",
    price: "30",
    ingredients:
      "350 gm pasta penne, 1 tablespoon butter, 5 cloves chopped garlic, 1 kilograms blanched & peeled,chopped tomato, 1 tablespoon tomato ketchup, 5 leaves basil, 1 teaspoon black pepper, 1 tablespoon extra virgin olive oil, 1 teaspoon thyme, 2 chopped dry red chili, 1 tablespoon white wine, 1 teaspoon sugar, salt as required",
    imageCover:
      "https://static.toiimg.com/thumb/84784534.cms?imgsize=468021&width=509&height=340",
    count: 1,
  },
  {
    id: 5,
    category: "Cookies",
    name: "Christmas Cookies",
    price: "20",
    ingredients:
      "200 gm all purpose flour, 1/2 teaspoon baking soda, 1 egg, 1 teaspoon icing sugar, 3 tablespoon unsalted butter, 1 1/2 tablespoon ground ginger, 1 teaspoon ground cinnamon, 2 tablespoon honey, 5 tablespoon brown sugar",
    imageCover:
      "https://static.toiimg.com/thumb/56022261.cms?imgsize=255315&width=509&height=340",
    count: 1,
  },
  {
    id: 6,
    category: "Cookies",
    name: "Snowball Cookies",
    price: "18",
    ingredients:
      "1 cup refined flour, 1 tablespoon corn flour, 1/4 cup powdered sugar, 1/2 cup butter, 1 teaspoon baking powder, 1/4 teaspoon salt",
    imageCover:
      "https://static.toiimg.com/thumb/88252447.cms?imgsize=82780&width=509&height=340",
    count: 1,
  },
  {
    id: 7,
    category: "Breakfast",
    name: "Tomato Basil Sandwich",
    price: "34",
    ingredients:
      "6 slices bread- brown, 9 leaves sweet basil, black pepper as required, 1 tablespoon oregano, 1 tablespoon garlic, 3 tomato, salt as required, 1 teaspoon chili flakes, 1 cup low fat mozzarella cheese",
    imageCover:
      "https://static.toiimg.com/thumb/93759089.cms?imgsize=59958&width=509&height=340",
    count: 1,
  },
];

export default recipes;
